//region imports
import { Injectable, Signal, signal, WritableSignal, OnDestroy } from '@angular/core';
import { filter, Subscription } from 'rxjs';
import { PageKey } from './models/page.key';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

//#endregion

@Injectable({
  providedIn: 'root'
})
export class PageService implements OnDestroy {

  //#region Constructor

  constructor(
    title: Title,
    router: Router,
    route: ActivatedRoute,
  ) {
    this.routerSubscription = router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let mainRoute = route.root.children[0].snapshot.data;

        let activeRoute = this.getActiveRoute(route);
        let currentRouteData = activeRoute.snapshot.data;

        this._page.set(currentRouteData['key'] || mainRoute['key'] || null);

        title.setTitle(mainRoute['title'] + ' | Plataforma');
      });
  }

  //#endregion

  //#region Public Properties

  public get page(): Signal<PageKey | null> {
    return this._page;
  }

  public set page(page: PageKey) {
    this._page.set(page);
  }

  //#endregion

  //#region Private Properties

  private routerSubscription?: Subscription;

  private readonly _page: WritableSignal<PageKey | null> = signal(null);

  //#endregion

  //#region Lifecycle Hooks

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  //#endregion

  //#region Private Methods

  private getActiveRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild)
      route = route.firstChild;

    return route;
  }

  //#endregion

}
